import styled from 'styled-components';

export const ThumbnailLinkContainer = styled.div`
  position: absolute;
  top: 0;
  z-index: 33;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.9);
  justify-content: center;

  @media only screen and (max-width: 960px) {
    height: 100%;
    padding-top: 10px;
  }

  h4 {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 18px;
    letter-spacing: -0.02em;
    text-decoration-line: underline;
    color: #ffffff;
    margin-bottom: 2.4rem;
    text-align: center;

    @media only screen and (max-width: 960px) {
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
`;

export const CancelBtn = styled.h3`
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;

  @media only screen and (max-width: 960px) {
    font-size: 14px;
  }
`;

export const StyledThumbnailLink = styled.div`
  width: 40%;
  height: 50%;
  position: relative;
  background: #ccc ${props => `url(${props.imgSrc})`} no-repeat;
  background-size: cover;
  cursor: pointer;

  & span > div {
    padding: 1.6rem 2rem;
    color: white;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;

    h4 {
      font-size: 1.4rem;
      line-height: 1.8rem;
      text-align: center;
    }

    h6 {
      font-size: 1rem;
      line-height: 1.3rem;
      text-align: center;
    }

    div {
      position: absolute;
      width: min-content;
      border-radius: 100px;
      padding: 0.2rem 1.2rem;
      font-size: 1.4rem;
      line-height: 1.9rem;
      background-color: rgba(0, 0, 0, 0.5);
      right: 1.2rem;
      bottom: 1.2rem;
      backdrop-filter: blur(0.5rem);

      @media (max-width: 1024px) {
        font-size: 0.8rem;
        line-height: 1rem;
        padding: 0.1rem 0.8rem;
      }
    }
  }

  img {
    display: inline-block;
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 1024px) {
    width: 50%;
  }
`;

export const CongratulationsText = styled.h2`
  color: #ba8d5b !important;
  max-width: 80%;
  font-size: 32px;
  text-align: center;

  @media only screen and (max-width: 1260px) {
    font-size: 24px;
    max-width: 90%;
  }

  @media only screen and (max-width: 960px) {
    font-size: 14px;
    max-width: 90%;
  }
`;

export const Title = styled.h3`
  font-size: 2.4rem;
  text-align: center;
  line-height: 3.2rem;
  font-weight: 500;
  margin-bottom: 2.4rem;
  color: ${props => props.theme.colors.white};

  @media (max-width: 1024px) {
    font-size: 1.4rem;
    line-height: 2rem;
    margin-bottom: 0.9rem;
  }
`;

export const CircularProgress = styled.div`
  position: relative;
  height: 80px;
  width: 80px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin: 0 auto 22px auto;
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    height: 84%;
    width: 84%;
    background-color: #000;
    border-radius: 50%;
  }

  @media only screen and (max-width: 960px) {
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
  }
`;

export const ValueContainer = styled.img`
  position: relative;
  width: 18px;
  height: 24px;
  object-fit: contain;

  @media only screen and (max-width: 960px) {
    width: 10px;
    height: 14px;
  }
`;
